import { render, staticRenderFns } from "./OverAccreditation.vue?vue&type=template&id=90c77792&"
import script from "./OverAccreditation.vue?vue&type=script&lang=js&"
export * from "./OverAccreditation.vue?vue&type=script&lang=js&"
import style0 from "./OverAccreditation.vue?vue&type=style&index=0&id=90c77792&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsAccreditation: require('/opt/build/repo/components/Cards/Accreditation.vue').default})
